import EmptyResult from 'components/others/EmptyResult';
import SetTableRow from './SetTableRow';
import type { ProductSetType } from '@econtractor/types';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';

interface SetTableBodyProps {
    setsList: ProductSetType[];
    fetchSets: (force?: boolean) => Promise<void>;
    setEditSetId: (setId: number) => void;
}

const SetTableBody = ({ setsList, fetchSets, setEditSetId }: SetTableBodyProps) => {
    const { auth } = useAuth();
    const colSpan = hasUserAccess(auth?.user, 'prodEdit') ? 7 : 6;

    return (
        <tbody>
            {setsList?.map((productSet) => (
                <SetTableRow
                    key={productSet.ID}
                    productSet={productSet}
                    fetchSets={fetchSets}
                    setEditSetId={setEditSetId}
                />
            ))}

            {setsList.length === 0 && (
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default SetTableBody;
